import { BASE_URL } from './endpoint.js';

function wsBaseURL() {
  if (BASE_URL) {
    // Dev: convert http://host:port → ws://host:port
    return BASE_URL.replace(/^http/, 'ws');
  }
  // Production: derive from current page location
  const proto = location.protocol === 'https:' ? 'wss:' : 'ws:';
  return proto + '//' + location.host;
}

function tokenIsValid() {
  const token = localStorage.getItem('token');
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 > Date.now();
  } catch (e) {
    return false;
  }
}

/**
 * Opens a WebSocket to path with the JWT token from localStorage.
 * Calls onMessage(parsedData) for each incoming message.
 * Calls onOpen() each time the connection is established (including reconnects).
 * Reconnects with exponential backoff on unexpected close.
 * Redirects to login if the token has expired on reconnect.
 * Returns a handle with a close() method to stop reconnecting.
 */
export function openWS(path, onMessage, onOpen) {
  let ws = null;
  let stopped = false;
  let delay = 1000;

  function connect() {
    if (stopped) return;
    if (!tokenIsValid()) {
      // Token missing or expired — send user to login instead of reconnecting.
      stopped = true;
      window.location.href = '/#/login';
      return;
    }
    const token = localStorage.getItem('token');
    const url = wsBaseURL() + path + '?token=' + encodeURIComponent(token);
    ws = new WebSocket(url);

    ws.onmessage = (e) => {
      try {
        const msg = JSON.parse(e.data);
        onMessage(msg);
      } catch (err) {
        console.error('ws parse error', err);
      }
    };

    ws.onclose = () => {
      if (stopped) return;
      setTimeout(() => {
        delay = Math.min(delay * 2, 30000);
        connect();
      }, delay);
    };

    ws.onerror = () => {
      // onerror is always followed by onclose; let onclose handle reconnect.
    };

    ws.onopen = () => {
      delay = 1000;
      if (onOpen) onOpen();
    };
  }

  connect();

  return {
    close() {
      stopped = true;
      if (ws) ws.close();
    },
    send(data) {
      if (ws && ws.readyState === WebSocket.OPEN) ws.send(data);
    },
  };
}



// WEBPACK FOOTER //
// ./src/ws.js